var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-crud',{attrs:{"crudName":"Nome do Processo","newText":"Novo Registro","table":_vm.table,"columns":_vm.columns,"options":_vm.options,"endPoint":_vm.endPoint,"enableAdd":true,"enableEdit":true,"enableDelete":true,"enableView":false,"dataForm":_vm.dataForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }